import { render, staticRenderFns } from "./Verify_Mail.vue?vue&type=template&id=0093c0fd&scoped=true&"
import script from "./Verify_Mail.vue?vue&type=script&lang=js&"
export * from "./Verify_Mail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0093c0fd",
  null
  
)

export default component.exports